module.exports = __webpack_public_path__ + "img/10 Buffet 3.jpg";